"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeClassName = exports.appendToHeader = exports.appendToBody = exports.addClassName = void 0;
var appendToBody = exports.appendToBody = function appendToBody(dom) {
  return document.body.appendChild(dom);
};
var appendToHeader = exports.appendToHeader = function appendToHeader(style) {
  return document.head.appendChild(style);
};
var addClassName = exports.addClassName = function addClassName(target) {
  var _target$classList;
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  target && ((_target$classList = target.classList) === null || _target$classList === void 0 ? void 0 : _target$classList.add(className));
};
var removeClassName = exports.removeClassName = function removeClassName(target) {
  var _target$classList2;
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  target && ((_target$classList2 = target.classList) === null || _target$classList2 === void 0 ? void 0 : _target$classList2.remove(className));
};